// Components/ChatContacts/hooks/useFilteredContacts.js
import { useMemo } from "react";

export const useFilteredContacts = (contacts, searchQuery, filterType) => {

    const normalizedQuery = searchQuery.toLowerCase().trim();

    const filteredContacts = useMemo(() => {
        if (!Array.isArray(contacts)) return [];

        let filtered = contacts.filter(contact => {

            const name = (contact.name || "").toLowerCase();
            const ejecutivo = (contact.ejecutivo_cuenta || "").toLowerCase();
            const phone = (contact.phone_number || "").toLowerCase();

            // 🔍 Busqueda en múltiples campos
            const matchesSearch =
                name.includes(normalizedQuery) ||
                ejecutivo.includes(normalizedQuery) ||
                phone.includes(normalizedQuery);

            return matchesSearch;
        });

        // 🔔 Filtro opcional de no leídos
        if (filterType === 'unread') {
            filtered = filtered.filter(contact => contact.received_messages_count > 0);
        }

        return filtered;
    }, [contacts, normalizedQuery, filterType]);


    // 🔢 Contador total de mensajes no leídos
    const unreadCount = useMemo(() => {
        if (!Array.isArray(contacts)) return 0;

        return contacts.reduce(
            (total, contact) => total + (contact.received_messages_count || 0),
            0
        );
    }, [contacts]);


    return { filteredContacts, unreadCount };
};
